import { combineReducers } from "redux";
import * as dataReducer from "./data";
import * as idObservadorReducer from "./idObservador";
import * as idEspecieReducer from "./idEspecie";
import * as peticioEnCursReducer from "./peticioEnCurs";
import * as valorsReducer from "./valors";
import * as dataDarreraIntroduccioReducer from "./dataDarreraIntroduccio";

const rootReducer = combineReducers({
  data: dataReducer.default,
  idObservador: idObservadorReducer.default,
  idEspecie: idEspecieReducer.default,
  peticioEnCurs: peticioEnCursReducer.default,
  valors: valorsReducer.default,
  dataDarreraIntroduccio: dataDarreraIntroduccioReducer.default
});

export default rootReducer;

export const getData = state => dataReducer.getData(state.data);
export const getDataAsMoment = state => dataReducer.getDataAsMoment(state.data);
export const getIdObservador = state =>
  idObservadorReducer.getIdObservador(state.idObservador);
export const getIdEspecie = state =>
  idEspecieReducer.getIdEspecie(state.idEspecie);
export const getPeticioEnCurs = state =>
  peticioEnCursReducer.getPeticioEnCurs(state.peticioEnCurs);
export const getPeticioError = state => {
  peticioEnCursReducer.getPeticioError(state);
};
export const getValors = state => valorsReducer.getValors(state.valors);
export const getDataDarreraIntroduccio = state =>
  dataDarreraIntroduccioReducer.getDataDarreraIntroduccio(
    state.dataDarreraIntroduccio
  );
